export const polarisUiSchema = {
    label: "Scan Settings",
    type: "HorizontalLayout",
    elements: [
        {
            type: "Group",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/Gen",
                    rule: {
                        effect: "DISABLE",
                        condition: {
                            scope: "#",
                            schema: {}, //always true
                        },
                    },
                },
            ],
        },
        {
            type: "Group",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/IOT",
                },
            ],
        },
        {
            type: "Group",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/Fota",
                },
            ],
        },
    ],
};
